import React, { createContext } from "react";

export const CompanyContext = createContext({});